var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlugCssMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48 48",
    style: {
      enableBackground: "new 0 0 48 48"
    },
    xmlSpace: "preserve",
    fill: "currentColor",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M18,19c-2.2060547,0-4,1.7939453-4,4s1.7939453,4,4,4s4-1.7939453,4-4S20.2060547,19,18,19z M18,25 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S19.1025391,25,18,25z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28,15c0-2.2060547-1.7939453-4-4-4s-4,1.7939453-4,4s1.7939453,4,4,4S28,17.2060547,28,15z M24,17 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S25.1025391,17,24,17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36,19c2.2060547,0,4-1.7939453,4-4s-1.7939453-4-4-4s-4,1.7939453-4,4S33.7939453,19,36,19z M36,13 c1.1025391,0,2,0.8974609,2,2s-0.8974609,2-2,2s-2-0.8974609-2-2S34.8974609,13,36,13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16,15c0-2.2060547-1.7939453-4-4-4s-4,1.7939453-4,4s1.7939453,4,4,4S16,17.2060547,16,15z M12,17 c-1.1025391,0-2-0.8974609-2-2s0.8974609-2,2-2s2,0.8974609,2,2S13.1025391,17,12,17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34,23c0-2.2060547-1.7939453-4-4-4s-4,1.7939453-4,4s1.7939453,4,4,4S34,25.2060547,34,23z M28,23 c0-1.1025391,0.8974609-2,2-2s2,0.8974609,2,2s-0.8974609,2-2,2S28,24.1025391,28,23z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15,32c-2.7568359,0-5,2.2431641-5,5s2.2431641,5,5,5s5-2.2431641,5-5S17.7568359,32,15,32z M15,40 c-1.6542969,0-3-1.3457031-3-3s1.3457031-3,3-3s3,1.3457031,3,3S16.6542969,40,15,40z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33,32c-2.7568359,0-5,2.2431641-5,5s2.2431641,5,5,5s5-2.2431641,5-5S35.7568359,32,33,32z M33,40 c-1.6542969,0-3-1.3457031-3-3s1.3457031-3,3-3s3,1.3457031,3,3S34.6542969,40,33,40z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 9,
    r: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.4267578,29.8203125C41.9833984,26.1074219,44,21.1396484,44,16c0-5.0927734-1.9326172-9.953125-5.4414062-13.6845703 C38.3691406,2.1142578,38.1064453,2,37.8300781,2H10.1699219C9.8935547,2,9.6308594,2.1142578,9.4414062,2.3154297 C5.9326172,6.046875,4,10.9072266,4,16c0,5.1396484,2.0166016,10.1074219,5.5732422,13.8203125 C7.3417969,31.5078125,6,34.1552734,6,37c0,4.9628906,4.0371094,9,9,9h18c4.9628906,0,9-4.0371094,9-9 C42,34.1552734,40.6582031,31.5078125,38.4267578,29.8203125z M33,44H15c-3.859375,0-7-3.140625-7-7 c0-2.5585938,1.3964844-4.9130859,3.6445312-6.1435547c0.2822266-0.1542969,0.4736328-0.4365234,0.5126953-0.7558594 c0.0380859-0.3203125-0.0791016-0.6396484-0.3164062-0.8574219C8.1289062,25.8330078,6,21.0068359,6,16 c0-4.4404297,1.6337891-8.6845703,4.609375-12h26.78125C40.3662109,7.3154297,42,11.5595703,42,16 c0,5.0068359-2.1289062,9.8330078-5.8408203,13.2431641c-0.2373047,0.2177734-0.3544922,0.5371094-0.3164062,0.8574219 c0.0390625,0.3193359,0.2304688,0.6015625,0.5126953,0.7558594C38.6035156,32.0869141,40,34.4414062,40,37 C40,40.859375,36.859375,44,33,44z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlugCssMedium);
export default __webpack_public_path__ + "static/media/plug-css--medium.1440e3c9d6c49e2547d65ebe314942f0.svg";
export { ForwardRef as ReactComponent };